<template>
  <v-row v-if="user">
    <template v-for="(item, i) in items">
      <v-col
        :key="i"
        cols="3"
      >
        {{ item.label }}:
      </v-col>
      <v-col
        :key="i + 'value'"
        cols="9"
        class="font-weight-bold"
      >
        <a
          v-if="item.link"
          :href="item.value"
          target="_blank"
          >{{ item.value }}</a
        >
        <template v-else>
          {{ item.value }}
        </template>
      </v-col>
    </template>

    <v-col cols="3"> Is Designer: </v-col>
    <v-col cols="9">
      <v-switch
        v-model="user.isDesigner"
        class="mt-0 pt-0"
        :loading="saving"
        hide-details @change="saveDesigner"
      />
    </v-col>
    <template v-if="user.isDesigner">
      <v-col cols="3"> Restricted Category: </v-col>
      <v-col cols="9">
        <v-select
          v-model="user.designerRestrictedCategoryId"
          :items="categories"
          outlined
          :loading="saving"
          hide-details="auto"
          dense
          item-value="id"
          item-text="name"
          @change="saveDesigner"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'UserCardDetails',
  data() {
    return {
      saving: false
    };
  },
  computed: {
    items() {
      return [
        { label: 'Email', value: this.user.email },
        {
          label: 'Date created',
          value: this.$options.filters.normalDateWithTime(this.user.createdDate)
        },
        {
          label: 'Last login',
          value: this.$options.filters.normalDateWithTime(this.user.lastLoginDate)
        },
        { label: 'Master account', value: this.user.masterAccount },
        { label: 'MCS ID', value: this.user.mcsId },
        { label: 'User Info ID', value: this.user.id },
        { label: 'Name', value: this.user.fullName },
        { label: 'Company', value: this.user.company },
        { label: 'Website', value: this.user.website, link: true },
        { label: 'Occupation', value: this.user.occupation },
        { label: 'Area of work', value: this.user.areaOfWork },
        { label: 'Plan', value: this.user.plan },
        { label: 'Plan status', value: this.user.planStatus },
        { label: 'Stripe ID', value: this.user.stripeId },
        { label: 'UTM Medium', value: this.user.utmMedium },
        { label: 'UTM Source', value: this.user.utmSource },
        { label: 'UTM Campaign', value: this.user.utmCampaign }
      ];
    },
    ...mapGetters({ user: 'users/user', categories: 'lookup/categories' })
  },
  methods: {
    saveDesigner() {
      this.saving = true;
      this.$store
        .dispatch('users/saveDesigner', this.user)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
